module.exports = __webpack_public_path__ + "static/img/BU01download.f569f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01download.jpg
// module id = oUcC
// module chunks = 1